/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CallFeedbackSettingBody } from '../models';
/**
 * CallFeedbackSettingApi - axios parameter creator
 * @export
 */
export const CallFeedbackSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コールFB設定取得API
         * @summary コールFB設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbackSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/call_feedback_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * コールFB設定更新API（upsert）
         * @summary コールFB設定更新API
         * @param {CallFeedbackSettingBody} callFeedbackSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCallFeedbackSetting: async (callFeedbackSettingBody: CallFeedbackSettingBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callFeedbackSettingBody' is not null or undefined
            assertParamExists('putCallFeedbackSetting', 'callFeedbackSettingBody', callFeedbackSettingBody)
            const localVarPath = `/api/user/call_feedback_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callFeedbackSettingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallFeedbackSettingApi - functional programming interface
 * @export
 */
export const CallFeedbackSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallFeedbackSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * コールFB設定取得API
         * @summary コールFB設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallFeedbackSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallFeedbackSettingBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallFeedbackSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * コールFB設定更新API（upsert）
         * @summary コールFB設定更新API
         * @param {CallFeedbackSettingBody} callFeedbackSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCallFeedbackSetting(callFeedbackSettingBody: CallFeedbackSettingBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCallFeedbackSetting(callFeedbackSettingBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallFeedbackSettingApi - factory interface
 * @export
 */
export const CallFeedbackSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallFeedbackSettingApiFp(configuration)
    return {
        /**
         * コールFB設定取得API
         * @summary コールFB設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallFeedbackSetting(options?: any): AxiosPromise<CallFeedbackSettingBody> {
            return localVarFp.getCallFeedbackSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * コールFB設定更新API（upsert）
         * @summary コールFB設定更新API
         * @param {CallFeedbackSettingBody} callFeedbackSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCallFeedbackSetting(callFeedbackSettingBody: CallFeedbackSettingBody, options?: any): AxiosPromise<void> {
            return localVarFp.putCallFeedbackSetting(callFeedbackSettingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallFeedbackSettingApi - interface
 * @export
 * @interface CallFeedbackSettingApi
 */
export interface CallFeedbackSettingApiInterface {
    /**
     * コールFB設定取得API
     * @summary コールFB設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackSettingApiInterface
     */
    getCallFeedbackSetting(options?: AxiosRequestConfig): AxiosPromise<CallFeedbackSettingBody>;

    /**
     * コールFB設定更新API（upsert）
     * @summary コールFB設定更新API
     * @param {CallFeedbackSettingBody} callFeedbackSettingBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackSettingApiInterface
     */
    putCallFeedbackSetting(callFeedbackSettingBody: CallFeedbackSettingBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putCallFeedbackSetting operation in CallFeedbackSettingApi.
 * @export
 * @interface CallFeedbackSettingApiPutCallFeedbackSettingRequest
 */
export interface CallFeedbackSettingApiPutCallFeedbackSettingRequest {
    /**
     * 
     * @type {CallFeedbackSettingBody}
     * @memberof CallFeedbackSettingApiPutCallFeedbackSetting
     */
    readonly callFeedbackSettingBody: CallFeedbackSettingBody
}

/**
 * CallFeedbackSettingApi - object-oriented interface
 * @export
 * @class CallFeedbackSettingApi
 * @extends {BaseAPI}
 */
export class CallFeedbackSettingApi extends BaseAPI implements CallFeedbackSettingApiInterface {
    /**
     * コールFB設定取得API
     * @summary コールFB設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackSettingApi
     */
    public getCallFeedbackSetting(options?: AxiosRequestConfig) {
        return CallFeedbackSettingApiFp(this.configuration).getCallFeedbackSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * コールFB設定更新API（upsert）
     * @summary コールFB設定更新API
     * @param {CallFeedbackSettingApiPutCallFeedbackSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallFeedbackSettingApi
     */
    public putCallFeedbackSetting(requestParameters: CallFeedbackSettingApiPutCallFeedbackSettingRequest, options?: AxiosRequestConfig) {
        return CallFeedbackSettingApiFp(this.configuration).putCallFeedbackSetting(requestParameters.callFeedbackSettingBody, options).then((request) => request(this.axios, this.basePath));
    }
}
